import AdminLayout from "@/components/feature/AdminLayout";
import { dashboardStats } from "@/mocks/admin/stats";
import StatCard from "./components/StatCard";
import PageHeader from "./components/PageHeader";
import RevenueChart from "./components/RevenueChart";
import TodaySchedule from "./components/TodaySchedule";

export default function Home() {
  return (
    <AdminLayout>
      <div className="px-4 md:px-8 py-6 md:py-8 max-w-[1600px] mx-auto space-y-6 md:space-y-7">
        <PageHeader />

        {/* Stat cards row */}
        <section className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
          {dashboardStats.map((s) => (
            <StatCard key={s.id} {...s} />
          ))}
        </section>

        {/* Revenue + Today's schedule — stacked so each gets the full width */}
        <section className="space-y-4 md:space-y-5">
          <RevenueChart />
          <TodaySchedule />
        </section>

        <footer className="pt-4 pb-2 text-center text-xs text-ink-400">
          Haulmark Movers · Operations Console · v0.1
        </footer>
      </div>
    </AdminLayout>
  );
}